import React from 'react';
import { Link } from 'react-router-dom';
import NewsImage from '../components/NewsImage';
import NewsSkeleton from '../components/NewsSkeleton';
import SectionHeaderLink from '../components/SectionHeaderLink';
import { useNewsFeedQuery } from '../hooks/useNewsListQuery';
import '../styles/SportNewsFeed.css';
import '../styles/HomeSectionTitle.css';

const SportNewsFeed = ({
  title,
  category,
  section,
  link,
  limit = 5,
}) => {
  const {
    news: newsList,
    initialLoading,
  } = useNewsFeedQuery({
    category,
    section,
    limitCount: limit,
  });

  if (initialLoading && newsList.length === 0) {
    return <NewsSkeleton count={3} />;
  }

  if (newsList.length === 0) return null;

  const firstNews = newsList[0];
  const restNews = newsList.slice(1);

  return (
    <div className="ukraine-news-box">
      <div className="panel">
        <SectionHeaderLink title={title} to={link} />
      </div>

      <Link to={`/news/${firstNews.id}`} className="main-ukraine-news">
        <NewsImage news={firstNews} alt={firstNews.title} loading="lazy" />

        <h3>{firstNews.title}</h3>

        <span className="ukraine-news-time">
          {firstNews.day}.{firstNews.month}.{firstNews.year}, {firstNews.time}
        </span>
      </Link>

      <ul className="ukraine-news-list">
        {restNews.map((news) => (
          <li key={news.id}>
            <Link to={`/news/${news.id}`}>
              {news.title}
              <span className="ukraine-news-time">
                {news.day}.{news.month}.{news.year}, {news.time}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SportNewsFeed;
